const awsExports = {
  Auth: {
    Cognito: {
      userPoolId:
        process.env.REACT_APP_USER_POOL_ID ?? "us-west-2_2L7ACWbh3",
      userPoolClientId:
        process.env.REACT_APP_USER_POOL_CLIENT_ID ?? "qakjmnneqcdio83eeh4hsb64n",
      loginWith: { email: true },
    },
  },
};

export default awsExports;
